const autoNgTemplateLoaderTemplate1 = require('./show-hide.html');

import angular from 'angular';

angular.module('shbdeployer.app').component('showHide', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    value: '<',
    useAsterisk: '<',
  },
});
